export const login = "/auth/login-with-otp";
export const signUp = "/auth/create-user";
export const forgotPassword = "/auth/send-forgot-password-link";
export const resetPassword = "/auth/reset-password";
export const verifyOtp = "/auth/verify-otp";
export const isRegistered = "/auth/check-location";